// ******************************************************************************

//    (C) 2022 AhnLab, Inc. All rights reserved.
//    Any part of this source code can not be copied with any method without
//    prior written permission from the author or authorized person.

// ******************************************************************************
import Vue from "vue";
import VueRouter from "vue-router";
import MainLayout from "../layouts/MainLayout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "UserMain",
        component: () => import("@/views/UserMain.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { path: "/error/404" },
  },
  {
    path: "/error/:status",
    name: "ErrorPage",
    component: () => import("@/components/common/ErrorPage.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
